import z from 'zod'

export const ClientTableStatusEnum = z.enum(['Current', 'Future', 'Notice', 'Past'])
export type ClientTableStatus = z.infer<typeof ClientTableStatusEnum>

export interface ClientModel {
  id: string
  phone: number
  apartment: number
  buildingNumber?: string | null
  street?: string | null
  user: {
    avatar: string
    createdAt: number
    deleted: boolean
    deletedAt: number
    email: string
    firstName: string
    id: number
    isActive: boolean
    lastName: string
    role: string
    updatedAt: number
  }
  buildingId: {
    id: number
    name: string
    code: string
    timezone: string
    PMS: boolean
  }
  moveInDate: number | null
  moveOutDate: number | null
  leaseStart: number | null
  leaseEnd: number | null
  statusPMS: {
    id: number
    status: ClientTableStatus
  }
  createdAt: number
  active: boolean
  isAppUser: boolean
  lastAppLogin: number | null
}
